import api from '@/api'
import Report from '@/api/communique/report'
import types from '@/types'

export interface OTTImpressionsByDayPartStat {
  day_part: string
  impressions: number
}

export interface queryParams {
  startDate?: string
  endDate?: string
  initiativeId?: string
  mediaTypes: string[]
  excludeLineItemIds?: string[]
  includeLineItemIds?: string
}

export class CampaignOTTImpressionsByDayPartStatsModel {
  public async fetchAll({
    initiativeId,
    mediaTypes,
    startDate,
    endDate,
    excludeLineItemIds,
    includeLineItemIds,
  }: queryParams): Promise<Report<OTTImpressionsByDayPartStat>> {
    return api('report.dashboards.ihmCampaign.v2.ott.impressionsByDayPartStats')
      .params({
        initiativeId: initiativeId,
        media_types: mediaTypes,
        start_date: startDate,
        end_date: endDate,
        exclude_line_item_ids: excludeLineItemIds,
        include_line_item_ids: includeLineItemIds,
      })
      .cache(1000 * types.config.dashboardCacheSeconds())
      .jsonMust<Report<OTTImpressionsByDayPartStat>>()
  }
}
